import React from 'react'
import Input from 'app/theme/forms/Input'
import LeadError from '../LeadError'
import { normalizeEatersValue, validateEaters, MAX_EATERS, MIN_EATERS } from 'app/utils/validation'

export default function LeadEaters(props) {
  const { data, setData, errors, setErrors } = props
  
  const placeholder = 'Around how many eaters are you planning to feed?'
  
  const handleBlur = () => {
    const normalized = normalizeEatersValue(data.eaters)
    const errorMessage = validateEaters(normalized)
    if (errorMessage) {
      setErrors({ eaters: errorMessage })
    } else if (normalized !== null && normalized !== 'invalid' && normalized !== data.eaters) {
      // Normalize the value on blur if valid
      setData(prev => ({
        ...prev,
        eaters: normalized,
      }))
    }
  }
  
  const handleChange = (eaters) => {
    // Clear errors on change
    setErrors(false)
    
    // Handle empty/null values
    if (eaters === null || eaters === undefined || eaters === '') {
      setData(prev => ({
        ...prev,
        eaters: null,
      }))
      return
    }
    
    // Handle NaN (invalid input that Input component converted)
    if (isNaN(eaters) || !isFinite(eaters)) {
      // Don't update state with NaN, keep current value or set to null
      // This allows user to continue typing to correct the input
      return
    }
    
    // Normalize value as user types (for edge cases like decimals)
    const normalized = normalizeEatersValue(eaters)
    
    // Update with normalized value if it's valid
    if (normalized !== null && normalized !== 'invalid') {
      setData(prev => ({
        ...prev,
        eaters: normalized,
      }))
    }
  }
  
  return (
    <div>
      <div className="p-8">
        <Input
          autoFocus
          type="number"
          min={MIN_EATERS}
          max={MAX_EATERS}
          value={data.eaters}
          error={errors?.eaters ? <LeadError className="text-center" message={errors.eaters} /> : null}
          data-test-id='eaters'
          placeholder={data.recurring ? 'Total number of eaters onsite' : placeholder}
          classNames={{
            input: 'input-underline text-center',
          }}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </div>
    </div>
  )
}
